import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '@src/components/Icon';

// Constants
import { ENTITY_SECURITY } from '@src/constants/Entities';

// Shared Components
import styles from './EntityCategoryLabel.scss';

export default function EntitySecurityLabel({ security }) {
  if (typeof security === 'undefined') return '-';
  const securityType = ENTITY_SECURITY.filter(
    item => item.value === security
  )[0];
  const { iconType, title } = securityType;
  return (
    <div className={`${styles.entityCategoryLabel}`}>
      <Icon iconType={iconType} size={20} /> {title}
    </div>
  );
}

EntitySecurityLabel.propTypes = {
  security: PropTypes.bool,
};
